import React from "react";
import { TransitionablePortal, Modal, Icon } from "semantic-ui-react";
import "./ModalTransition.css";

type Props = {
  id?: string;
  open?: boolean;
  size?: "small" | "mini" | "tiny" | "large" | "fullscreen";
  animation?: string;
  duration?: number;
  header?: any;
  content?: any;
  actions?: any;
  handleClose?: any;
  closeOnDimmerClick?: boolean;
  isForIframe?:boolean;
  style?:object;
};

const ModalTransition = React.forwardRef((props: Props, ref) => {
  /**
   * Gestion de la fermeture de modal
   */
  const handleClickClose = () => {
    document.body.classList.remove("modal-fade-in");
    props.handleClose();
  };

  /**
   * Retourne la partie body de la modal
   * @returns Object jsx
   */
  const getContent = (ref) => {
    let contentStyle = {
      maxHeight: props.isForIframe ? "inherit" : "65vh",
      height: props.isForIframe ? "100%" : "inherit",
      overflow: props.isForIframe ? "hidden" : "auto"
    }

    return props.content ? (
      <Modal.Content style={{height: props.isForIframe ? "94%" : "inherit"}}>
        <div ref={ref} style={contentStyle}>
          {props.content}
        </div>
      </Modal.Content>
    ) : null;
  };

  /**
   * Retourne la partie footer de la modal
   * @returns Object jsx
   */
  const getActions = () => {
    return props.actions ? (
      <Modal.Actions>{props.actions}</Modal.Actions>
    ) : null;
  };

  const animation = props.animation !== undefined ? props.animation : "scale";
  const duration = props.duration !== undefined ? props.duration : 500;

  /**
   * Rendu du module
   * @returns Object jsx
   */
  return (
    <TransitionablePortal
      open={props.open}
      transition={{ animation, duration }}
      onOpen={() => document.body.classList.add("modal-fade-in")}
      onClose={handleClickClose}
    >
      <Modal
        id={props.id}
        open={true}
        onClose={handleClickClose}
        closeOnDimmerClick={props.closeOnDimmerClick}
        size={props.size ? props.size : "small"}
        className="modalTransition"
        style={props.style}
      >
        <Modal.Header>
          <small>{props.header}</small>
          <Icon
            name="close"
            className="float-right"
            id="iconDeleteModal"
            onClick={handleClickClose}
          />
        </Modal.Header>
        {getContent(ref)}
        {getActions()}
      </Modal>
    </TransitionablePortal>
  );
});

export default ModalTransition;
